<style lang="less" scoped>
@import '../../../style/common/variable';
.footer{position: relative;height: 300px;width: 100%;margin: 0px auto;background: url('../../../../static/images/官网首页/db_bg.png') no-repeat; background-size: 100% 100%;border-top: solid rgb(41, 146, 245);display: flex;justify-content: center;}
.content{position: absolute; top: 0.4rem;}
ul{list-style: none;display: flex;}
li{flex: 1;font-size: 17px;height: 42px;
  span:hover{cursor: pointer;}
}
span{margin: 0 0.1rem;color: white;}
.second {font-size: 0.16rem;
  p {margin: 0.14rem 0;color: white;text-align: center;
    a {color: white;}
    img {width: 20px;height: 20px;}
  }
}
img {width: 123px;vertical-align: middle;}
</style>

<template>
  <div class="footer">
    <div class="content">
      <div>
        <ul>
          <li>
            <router-link to="/Gywm"><span> 关于我们 </span></router-link>
            <router-link to="/Wzsm"><span> 网站声明 </span></router-link>
          </li>
        </ul>
      </div>
      <div class="second">
        <p>版权所有：中国—东盟矿业信息服务平台 COPYRIGHT©2017-2018</p>
        <p>维护单位：中国—东盟地学合作中心(南宁)</p>
        <p>广西南宁市青秀区建政路1号</p>
        <p class="security"><a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">桂ICP备2021007495号&nbsp;&nbsp; </a><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo"><img src="../../../../static/images/zlkindex/ic_pb.png" alt="">桂公网安备&nbsp;&nbsp; 45010302002635号</a></p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 底部组件
 */
export default {
  methods:
  {
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Footer.vue